// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-dialog{border-radius:0!important;overflow-y:auto;max-height:50%!important}", ""]);
// Exports
module.exports = exports;
